import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
}

const getCommonStyle = () => css`
  padding-bottom: 145px;

  &.is-old-app-iphonex {
    padding-bottom: 179px;
  }

  #header .inner-header {
    border-bottom: 1px solid #eee;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding-bottom: ${mixin.pxToVw('145')};

    &.is-old-app-iphonex {
      padding-bottom: ${mixin.pxToVw('179')};
    }
  }
`;

export const SubLayout = styled.div<IProps>`
  #header .inner-header {
    position: fixed;
    top: 0;
  }

  body.airbridge-banner-opened & {
    #header {
      position: sticky;
      top: 0;

      .inner-header {
        position: static;
      }
    }

    #container {
      position: relative;
      z-index: 10;
      background-color: #fff;
    }
  }

  &.for-you-page,
  &.best-page {
    ${getCommonStyle};

    .area-menu {
      position: sticky;
      z-index: 10;
      top: 50px;
    }
  }

  &.sale-page {
    ${getCommonStyle};

    /* 구필터바(.filter-listbar) 구조 : 블록을 통째로 고정한다 */
    .area-menu:not(:has(.lp-filter-bar)) {
      position: sticky;
      z-index: 10;
      top: 50px;
    }

    /* LP 필터바 구조 : 1행(퀵 필터)은 고정 제외 대상이라 래퍼는 흘려보내고
       카테고리 탭과 필터바 .pin-area를 각각 sticky로 잡는다(각자 제 위치에서 고정) */
    .area-menu:has(.lp-filter-bar),
    .area-menu:has(.lp-filter-bar) .inner-area-menu,
    .area-menu .lp-filter-bar {
      display: contents;
    }

    .area-menu:has(.lp-filter-bar) .category-menubar {
      position: sticky;
      z-index: 10;
      top: 50px;
      background-color: #fff;
    }

    /* 고정된 카테고리 탭(type5 50px) 바로 아래 */
    .area-menu .lp-filter-bar .pin-area {
      position: sticky;
      z-index: 10;
      top: 100px;
    }

    @media ${({ theme }) => theme.media.smMax} {
      .area-menu .lp-filter-bar .pin-area {
        top: calc(50px + ${mixin.pxToVw('49')});
      }
    }
  }

  &.new-page {
    ${getCommonStyle};

    /* 1행(퀵 필터)은 고정 제외 → 래퍼는 흘려보내고 .pin-area만 sticky */
    .lp-filter-bar {
      display: contents;

      .pin-area {
        position: sticky;
        z-index: 10;
        top: 50px;
      }
    }
  }

  &.exclusive-page {
    ${getCommonStyle};

    .tabs .tabs-label,
    .tabs .filter-listbar,
    .tabs .sorting-accrdn {
      position: sticky;
      z-index: 10;
    }

    /* 1행(퀵 필터)은 고정 제외 → 래퍼는 흘려보내고 .pin-area만 sticky */
    .tabs .lp-filter-bar {
      display: contents;

      .pin-area {
        position: sticky;
        z-index: 10;
      }
    }

    .tabs .tabs-label {
      top: 50px;
    }

    .tabs .filter-listbar,
    .tabs .lp-filter-bar .pin-area,
    .tabs .sorting-accrdn {
      top: 95px;
    }
  }

  &.wlabel-page {
    ${getCommonStyle};

    // 메인배너가 없는 경우 헤더
    &:not(:has(.corner-main-banner)) {
      &.transparent-header {
        #header .inner-header {
          background: #fff;
          border-bottom: 1px solid #eee;

          svg {
            path,
            rect {
              fill: #000;
            }
          }

          .btn-cart .count {
            color: #fff;
            background-color: #000;
          }

          .title {
            color: #000;
          }
        }
      }
    }

    // 메인배너가 있는 경우 헤더
    &:has(.corner-main-banner) {
      #header .inner-header {
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.17) 0%,
          rgba(0, 0, 0, 0) 100%
        );
        border-bottom: 0;
      }

      &.transparent-header {
        &.is-fix-header {
          #header .inner-header {
            background: #fff;
            border-bottom: 1px solid #eee;

            svg {
              path,
              rect {
                fill: #000;
              }
            }

            .btn-cart .count {
              color: #fff;
              background-color: #000;
            }

            .title {
              color: #000;
            }
          }
        }

        .content {
          margin-top: -50px;
        }
      }
    }
  }

  &.brand-page,
  &.coupon-page,
  &.my-haert-collection-page,
  &.time-sale-page,
  &.history-page,
  &.specialty-page {
    ${getCommonStyle};
  }

  &.designer-page {
    ${getCommonStyle};

    &:has(.error-cont) {
      padding-bottom: 0;
    }
  }

  &.discovery-keywords-page,
  &.discovery-page {
    background-color: #1a1a1a;
    padding-bottom: 0;
  }

  &.discovery-page {
    #header,
    #actionbar {
      touch-action: none;
    }

    #header .inner-header {
      border-bottom: 0;
    }

    .discovery-main-template {
      height: calc(100dvh - 100px);
    }

    &.is-old-app-iphonex {
      .discovery-main-template {
        height: calc(100dvh - 134px);
      }
    }
  }

  &.discovery-keywords-page {
    &.is-old-app-iphonex {
      .discovery-sub-template {
        padding-bottom: 204px;
      }
    }

    #header .inner-header {
      border-bottom: 1px solid #333;
    }
  }

  &.style-clip-keywords-page,
  &.style-clip-page,
  &.style-clip-detail-page {
    ${getCommonStyle};

    padding-bottom: 170px;

    &.is-old-app-iphonex {
      padding-bottom: 204px;
    }
  }

  &.followlist-page,
  &.style-clip-profile-info-page {
    ${getCommonStyle};

    #header .inner-header {
      border-bottom: 0;
    }

    padding-bottom: 170px;

    &.is-old-app-iphonex {
      padding-bottom: 204px;
    }
  }

  &.shortform-page {
    background-color: #000;

    #header,
    #actionbar {
      touch-action: none;
    }

    #container > .content {
      margin-top: -50px;
      width: 100vw;
      height: calc(100dvh - 50px);
    }
  }

  &.category-page,
  &.myheart-page {
    ${getCommonStyle};

    #header .inner-header {
      border-bottom: 0;
    }
  }

  &.event-subLayout {
    #header .inner-header {
      border-bottom: 1px solid #eee;
    }

    &.transparent-header {
      &.is-fix-header {
        #header .inner-header {
          background: #fff;
          border-bottom: 1px solid #eee;

          svg {
            path,
            rect {
              fill: #000;
            }
          }

          .title {
            color: #000;
          }
        }
      }

      #header .inner-header {
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.12) 0%,
          rgba(0, 0, 0, 0) 100%
        );
        border-bottom: 0;

        svg {
          path,
          rect {
            fill: #fff;
          }
        }

        .title {
          color: #fff;
        }
      }

      .content {
        margin-top: -50px;
      }
    }

    .view-product-btn {
      position: fixed;
      bottom: 34px;
      left: 0;
      right: 0;
      z-index: 99;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease 0s, visibility 0.3s ease 0s;
      margin: 0 auto;

      &.active {
        opacity: 1;
        visibility: visible;
      }
    }

    .btn-top {
      position: fixed;
      bottom: 118px;
      right: 16px;
      z-index: 90;
      opacity: 0;
      visibility: hidden;

      &.active {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.3s ease 0s, visibility 0.3s ease 0s;
      }

      &.TopBtnOld {
        bottom: 129px;
      }
    }

    .share-btn-wrap {
      position: fixed;
      bottom: 34px;
      right: 16px;
      z-index: 99;
      opacity: 1;
      visibility: visible;
      transition: bottom 0.3s ease;

      .share-btn + .share-btn {
        margin-top: 6px;
      }

      .share-btn.EvtShareBtnV2 + .share-btn.EvtShareBtnV2 {
        margin-top: 8px;
      }
    }

    &:has(.share-btn:only-child) {
      .btn-top {
        bottom: 76px;

        &.TopBtnOld {
          bottom: 82px;
        }
      }
    }
  }

  &.lnb-page {
    #container {
      padding-bottom: 0;
    }

    .lnb-service-bar {
      position: sticky;
      z-index: 10;
      top: 50px;
      background: #fff;
    }

    &.is-old-app-iphonex {
      .depth1-area .depth1-list,
      .lnb-category-section:last-child {
        padding-bottom: 124px;
      }
    }
  }

  &.mega-promotion-page {
    padding-bottom: 145px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.discovery-page {
      .discovery-main-template {
        height: calc(100dvh - 50px - ${mixin.pxToVw('50')});
      }

      &.is-old-app-iphonex {
        .discovery-main-template {
          height: calc(100dvh - 50px - ${mixin.pxToVw('84')});
        }
      }
    }

    &.followlist-page,
    &.style-clip-profile-info-page,
    &.style-clip-keywords-page,
    &.style-clip-page,
    &.style-clip-detail-page {
      padding-bottom: ${mixin.pxToVw('170')};

      &.is-old-app-iphonex {
        padding-bottom: ${mixin.pxToVw('204')};
      }
    }

    &.shortform-page {
      #container > .content {
        height: calc(100dvh - ${mixin.pxToVw('50')});
      }
    }

    &.exclusive-page {
      .tabs .filter-listbar,
      .tabs .lp-filter-bar .pin-area,
      .tabs .sorting-accrdn {
        top: calc(50px + ${mixin.pxToVw('45')});
      }
    }

    &.event-subLayout {
      .view-product-btn {
        bottom: ${mixin.pxToVw('34')};
      }

      .btn-top {
        bottom: ${mixin.pxToVw('118')};
        right: ${mixin.pxToVw('16')};

        &.TopBtnOld {
          bottom: ${mixin.pxToVw('129')};
        }
      }

      .share-btn-wrap {
        bottom: ${mixin.pxToVw('34')};
        right: ${mixin.pxToVw('16')};

        .share-btn + .share-btn {
          margin-top: ${mixin.pxToVw('6')};
        }

        .share-btn.EvtShareBtnV2 + .share-btn.EvtShareBtnV2 {
          margin-top: ${mixin.pxToVw('8')};
        }
      }
    }

    &.mega-promotion-page {
      padding-bottom: ${mixin.pxToVw('145')};
    }

    &.lnb-page.is-old-app-iphonex {
      .depth1-area .depth1-list,
      .lnb-category-section:last-child {
        padding-bottom: ${mixin.pxToVw('124')};
      }
    }
  }
`;
